// extracted by mini-css-extract-plugin
export var modalBox = "C_vp";
export var backdrop = "C_vq";